export const TEMPLATES_SORTING_OPTIONS = [
  {
    value: 'title',
    label: 'Alfabetisk',
  },
  {
    value: 'date',
    label: 'Kronologisk',
  },
] as const
